// extracted by mini-css-extract-plugin
export var legal = "Legal-module--legal--7dac0";
export var legalLink = "Legal-module--legalLink--e4c51";
export var mobileOnly = "Legal-module--mobileOnly--995bd";